export enum FeatureTypeEnum {
  Metered = 'metered',
  Boolean = 'boolean'
}

export interface FeatureModel {
  featureId: string;
  units: string;
  unitsPlural: string;
  isUnlimited?: boolean;
  currentUsage?: number;
  usageLimit?: number;
  remainedUsage?: number;
  hasAccess: boolean;
  featureType: FeatureTypeEnum;
}
